import Container from "./container";
import React from "react";
import { getCatUrl } from "../lib/helpers";
import { cn } from "../lib/helpers";
import { Link } from "gatsby";

import * as styles from "../styles/components/page-header.module.css";

const PageHeader = (props) => {
  const {
    title,
    description,
    category,
    time,
  } = props;

  return (
    <div className={styles.root}>
      <Container>
        <div className="content-xxl">
          {title && <h1 className={cn("h2", styles.title)}>{title}</h1>}
          {(category || time) && 
            <div className={styles.meta}>
              {category && category.slug && 
                <span className={styles.item}>
                  <Link to={getCatUrl("blog-resources", category.slug)}>
                    {category.title}
                  </Link>
                </span>
              }
              {time && <span className={styles.item}>{time} Minute Read</span>}
            </div>
          }
        </div>
        {description && <div className="content-lg"><p>{description}</p></div>}
      </Container>
    </div>
  );
}

export default PageHeader;
